import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import BasePopover from '/component/base/Popover';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {showAlert} from '/util/alert.util';
import {copyToClipboard} from '/util/clipboard.util';

import {styles} from './ShareStreakPopover.style';

interface ShareStreakPopoverProps {
  shareMessage: string;
  shareTitle: string;
  popoverClose: () => void;
}

const ShareStreakPopover: React.FC<ShareStreakPopoverProps> = ({
  shareMessage,
  shareTitle,
  popoverClose,
}) => {
  const handleCopy = () => {
    copyToClipboard(shareMessage);
    showAlert({
      title: shareTitle,
      text: 'Streak message copied to clipboard!',
    });
    popoverClose();
  };

  const handleEmail = () => {
    const mailtoUrl = `mailto:?subject=${encodeURIComponent(
      shareTitle,
    )}&body=${encodeURIComponent(shareMessage)}`;
    window.location.href = mailtoUrl;
    popoverClose();
  };

  return (
    <BasePopover padded={false}>
      <View style={styles.container}>
        <View style={styles.header}>
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.headerTitle}
            isBold>
            {shareTitle}
          </Text>
          <TouchableOpacity
            onPress={popoverClose}
            style={styles.closeButton}
            accessibilityRole="button"
            accessibilityLabel="Close">
            <Icon name="close" size={24} style={styles.closeIcon} />
          </TouchableOpacity>
        </View>

        <View style={styles.content}>
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.messagePreview}>
            {shareMessage}
          </Text>

          <View style={styles.optionsGrid}>
            <TouchableOpacity
              style={styles.optionItem}
              onPress={handleEmail}
              accessibilityRole="button"
              accessibilityLabel="Share streak by email">
              <View style={[styles.iconWrapper, styles.emailIconWrapper]}>
                <Icon name="email" size={32} style={styles.emailIcon} />
              </View>
              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                style={styles.optionLabel}>
                Email
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.optionItem}
              onPress={handleCopy}
              accessibilityRole="button"
              accessibilityLabel="Copy streak message">
              <View style={[styles.iconWrapper, styles.copyIconWrapper]}>
                <Icon name="copy" size={32} style={styles.copyIcon} />
              </View>
              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                style={styles.optionLabel}>
                Copy
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </BasePopover>
  );
};

export default ShareStreakPopover;
